import angular from 'angular';
import emailRecipientsField from './emailRecipientsField';
import './style.scss';

export default angular
  .module('emailRecipientsField', [])
  .component('emailRecipientsField', emailRecipientsField).name;
